export default {
  globals: {
    order_status_breakdown: 'Order status breakdown',
    items_created_vs_fulfilled: 'Items created vs fulfilled',
    gps_only_cables: 'GPS-only cable',
    cables: 'Cables',
    boxes: 'Boxes',
    fieldtracker_reference: "Fieldtracker reference",
    device_type: "Device type",
    clear_filters: "Clear filters",
    no_synatec_orders_found: "No Sinatec order found",
    no_invoices_found: "No invoices found",
    no_scheduled_invoices_found: "No scheduled invoices found",
    type: "Type",
    request_fieldtracker_service: "Request fieldtracker service",
    export: "Export",
    non_applicable: "Non applicable",
    direct_debit_exact: "Direct debit (Exact)",
    direct_debit_mollie: "Direct debit (Mollie)",
    half_year: "Half year",
    including_btw: "incl. VAT",
    contract: "Contract",
    send_invoices: "Send invoices",
    approve: "Approve",
    units: "Units",
    close: "Close",
    view_audits: "View audits",
    synatec_orders_export: "Sinatec orders export",
    no_devices_found: "No devices found",
    confirmed: "Confirmed",
    search_for: "Search for",
    search: "Search",
    webshop_items: "Webshop items",
    all_items: "All items",
    page: "page",
    of: "of",
    resolved: "resolved",
    no_results: "no results",
    arr: "ARR",
    billing: "Billing",
    login: "Login",
    sign_in: "Sign In",
    email: "Email",
    cc_email: "CC Email",
    address: "Address",
    first_name: "First name",
    last_name: "Last name",
    scheduled_invoices: "Scheduled invoices",
    orders_inquiries: "Orders / Inquiries",
    inquiries: "Inquiries",
    orders: "Orders",
    all: "All",
    all_inquiries: "All inquiries",
    all_orders: "All orders",
    invoice: "Invoice",
    invoices: "Invoices",
    new: "New",
    new_order: "New order",
    new_inquiry: "New inquiry",
    new_customer: "New customer",
    parking: "Parking",
    inventory: "Inventory",
    system: "System",
    settings: "Settings",
    signout: "Signout",
    customers: "Customers",
    lang: "Lang",
    items: "Items",
    permissions: "Permissions",
    type_to_search: "Type to Search",
    new_item: "New Item",
    item: "Item",
    type: "Type",
    name: "Name",
    name_type: "Name/Type",
    empty: "Empty",
    name_already_exists: "Name already exists",
    fleet_size: "Fleet size",
    first_order: "First order",
    contract_duration: "Contract duration",
    price_once: "Price/Once",
    price_monthly: "Price/Monthly",
    vat: "VAT",
    brand: "Brand",
    brands: "Brands",
    currency: "Currency",
    discount: "Discount",
    add_new_item: "Add new item",
    add: "Add",
    description: "Description",
    password: "Password",
    confirm: "Confirm",
    save: "Save",
    edit: "Edit",
    yes: "Yes",
    no: "No",
    partialy_save: "Partialy Save",
    next: "Next",
    back: "Back",
    cancel: "Cancel",
    other: "Other",
    delete: "Delete",
    select: "Select",
    clear: "Clear",
    cant_change_brand: "Brand change possible only on home screen",
    add_item: "Add item",
    item_successfully_saved: "Item successfully saved...",
    per_page: "per page",
    created: "Created",
    show_pdf: "show .pdf",
    showing: "showing",
    are_you_sure_you_want_to_delete_this_item:
      "Are you sure you want to delete this item",
    are_you_chris_sure: "Would this inquiry make Christian proud?",
    all_customers: "All customers",
    customer_information: "Customer information",
    new_customer_information: "New customer information",
    billing_information: "Billing information",
    shipping_information: "Shipping information",
    company: "Company information",
    mandatory: "mandatory",
    user: "User",
    country: "Country",
    notes: "Notes",
    enter_notes: "Enter notes",
    contact: "Contact information",
    phone: "Phone",
    house_number: "House number",
    street_house_number: "Street and house number",
    street_name: "Street name",
    postal_code: "Postal code",
    city: "City",
    copy_to_shipping: "Copy to shipping",
    new_nquiry: "New inquiry",
    add_new: "Add new",
    select_existing_customer: "Select existing cutomer",
    set_starting_date: "Set starting date",
    retroactive_invoicing: "Retroactive Invoicing",
    retroactive_invoicing_description: "Invoices are sent at the end of each billing period - 5 days instead of at the beginning (e.g., invoice sent on Dec 26 for period Oct 1 - Dec 31)",
    total: "Total",
    initial_payment: "Initial payment",
    devices: "Devices",
    grand_total: "Contract value",
    finalize: "Finalize",
    all_orders_and_inquiries: "All orders and inquires",
    duration: "Duration",
    consultant: "Consultant",
    payment_term: "Payment term",
    payment_method: "Payment method",
    payments: "payments",
    one_time: "One time cost",
    select_customer: "Select customer",
    make_order: "Make an order",
    category: "Category",
    quantity: "Quantity",
    quantity_short: "Quan.",
    discount_per_item: "Discount/Item",
    tab: "Tab",
    inquiry: "Inquiry",
    add_inquiry: "Add Inquiry",
    customer_must_be_complete: "Customer must be complete!",
    order_already_exists: "Order already exists for this Inquiry",
    go_to_customer: "Go to customer",
    go_to_inquiry: "Go to inquiry",
    order: "Order",
    customer: "Customer",
    start_date: "Start date",
    date_created: "Date created",
    status: "Status",
    months: "months",
    order_devices: "Order devices",
    shedule_invoices: "Schedule invoices",
    new_inquiry_group: "New inquiry group",
    open: "Open",
    submit: "Submit",
    is_device: "Is a device",
    is_lease: "Is lease",
    existing_inquiries: "There are existing inquiries for selected customer",
    click_on_inquiry_redirect: "Click on inquiry to redirect",
    select_inquiry: "Select inquiry",
    price_list: "Price list",
    paid: "Paid",
    not_paid: "Not paid",
    all_permissions: "All permissions",
    for: "for",
    enable: "Enable",
    disable: "Disable",
    send_registration_email: "Send registration email",
    are_you_sure: "Are you sure?",
    complete: "Complete",
    select_country: "Select Country",
    agent: "Agent",
    agents: "Agents",
    creation_date: "Creation date",
    created_at: "Created at",
    due_days: "Due days",
    total_price: "Total price",
    total_value: "Total value",
    item_name: "Item name",
    value_no_vat: "Value no VAT",
    vat_price: "VAT",
    contr_dur: "Contr. dur.",
    paid_at: "Paid at",
    due_date: "Due date",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    schedule_at: "Schedule at",
    terminate_recall: "Terminate / Recall",
    new_device: "New device",
    old_device: "Old device",
    recall: "Recall",
    terminate: "Terminate",
    terminate_order: "Terminate Order",
    terminate_all_devices_warning: "All ACTIVE devices will be terminated!",
    termination_reason: "Termination reason",
    termination_only: "Termination only",
    if_empty_termination_only: "If empty, termination only",
    device_action: "Device action",
    are_you_sure_to: "Are you sure to",
    this_device: "this device",
    history: "History",
    action: "Action",
    invoices_scheduled: "Invoices / Sheduled",
    items_settings: "Items / Settings",
    create_new: "Create new",
    credit: "Credit",
    credits: "Credits",
    enter_amount: "Enter amount",
    create: "Create",
    prices_include_vat: "Price don't include vat",
    data: "Data",
    po_number: "PO Number",
    new_credit: "New credit",
    total_price_with_vat: "Total with VAT",
    invoice_number: "Invoice no.",
    resend: "Resend",
    total_price_no_vat: "Total no VAT",
    credit_invoice: "Credit invoice",
    sent_at: "Sent at",
    sent_from: "Send from",
    order_no: "Order no.",
    number: "Number",
    load: "Load",
    set_new_starting_date: "Set new starting date",
    range: "Range",
    select_range: "Select range",
    show: "Show",
    devices_sold: "Devices sold",
    quarter: "Quarter",
    new_orders: "New orders",
    invoices_sent: "Invoices sent",
    new_inquiries: "New inquiries",
    year: "Year",
    month: "Month",
    today: "Today",
    daily: "Daily",
    yesterday: "Yesterday",
    lost: "Lost",
    export_exact: "Export exact",
    download: "Download",
    date_range: "Date Range",
    select_date_range_to_export: "Select a date range to export your data",
    select_export_option: "Select an export option from the tabs below",
    weekly: "Weekly",
    past: "Past",
    current: "Current",
    monthly: "Monthly",
    yearly: "Yearly",
    highlights: "Highlights",
    quarterly: "Quarterly",
    ratio: "Ratio",
    new_customers: "New customers",
    avg_duration: "Avg. duration",
    hard_delete: "Hard delete",
    self_replace: "Self replace",
    all_devices: "All devices",
    import_exact: "Import exact",
    debiteur_no: "Debiteur no.",
    from_debiteur_no: "From debiteur no.",
    installations: "Installations",
    all_installations: "All Installations",
    installation_type: "Installation type",
    terminations: "Terminations",
    all_terminations: "All Terminations",
    connection_status: "Conn. status",
    sent_to: "Sent to",
    re_sent_at: "Re-sent at",
    internal_notes: "Internal notes",
    cancel_order: "Cancel order",
    revenue: "Revenue",
    future: "Future",
    amounts: "Amounts",
    amount: "Amount",
    sum: "Sum",
    canceled: "Canceled",
    terminated: "Terminated",
    warranty: "Warranty",
    based_on_contract_duration: "Based on contract duration",
    based_on_average_contract_length: "Based on average contract length",
    from_invoice_no: "From invoice no.",
    invoice_no: "Invoice no.",
    set: "Set",
    transfer: "Transfer",
    to_another_order: "to another order",
    not_affecting_web_app: "Not affecting web app (Only in billing)",
    change_quantity_from: "Change quantity from",
    new_quantity: "New quantity",
    add_device: "Add device",
    clear_csv: "Clear .csv",
    inst_form: "Inst. form",
    ins_form: "Ins. form",
    download_csv: "Download CSV",
    delete_also_inquiry: "Delete also Inquiry",
    left_unchecked_pending:
      "If left empty (unchecked) the Inquiry will go back to 'pending' status",
    request_service: "Request service",
    replacement: "Replacement",
    install: "Install",
    main: "Main",
    request_replace: "Request replace",
    select_device: "Select device",
    assembly: "Assembly",
    reason: "Reason",
    billed: "Billed",
    replace: "Replace",
    old: "Old",
    edit_new_imei: "Edit new imei",
    request: "Request",
    request_fieldtracker: "Request fieldtracker",
    fieldtracker_service: "Fieldtracker service",
    contact_information: "Contact info",
    to_be_billed: "To be billed",
    affect_web_app: "Affect webapp",
    all_services: "All services",
    services: "Services",
    service: "Service",
    service_type: "Service type",
    order_services: "Order Services",
    services_services: "Services",
    service_service: "Service",
    to_web_app: "To web app",
    parking_invoices: "Parking Invoices",
    change_price_from: "Change price from",
    new_price: "New price",
    select_month: "Select month",
    contract_details: "Contract details",
    shared_web_app_id_detected: "Shared web app ID detected",
    used_as_default: "Used as default",
    not_used_as_default: "Not used as default",
    contract_type: 'Type of contract',
    contract_termination_policy: 'Contract termination policy',
    custom_order_item: 'Custom order item',
    no_billing_item: 'No billing item',
    info_from_orders: 'Information from orders',
    loading: 'Loading...',
    monthly_price: "Monthly price",
    price_reason_ambiguous_line: "Multiple order items match this device, so the price could not be determined",
    price_reason_calculation_error: "An error occurred while calculating the price",
    price_reason_unknown: "The price could not be determined",
    customer_notes: "Customer notes",
    import_exact_parking: "Import exact parking",
    no_parkings: "No. Parkings",
    parkings_value: "Parkings value",
    no_fees: "No. Fees",
    fees_value: "Fees value",
    first_payment: "First payment",
    costs: "Costs",
    source: "Source",
    all_sources: "All sources",
    change_agent: "Change agent",
    period_from: "Period from",
    select_company: "Select company",
    set_up: "Set up",
    mollie_parkings: "Mollie Parkings",
    mollie_orders: "Mollie Orders",
    mollie_payments: "Mollie Payments",
    import_tool: "Import tool",
    change_payment_type: "Change payment type",
    invoice_type: "Invoice type",
    orders_export: "Orders Export",
    update_selected: "Update selected",
    import_stock: "Import stock",
    add_devices_from_stock: "Add devices from stock",
    manual: "Manual",
    payment_type: "Payment type",
    add_a_sold_event_for_these_devices: "Add a sold event for these devices",
    price_per_device_ex_vat: "Price per device ex. vat",
    sold_at: "Sold at",
    batch: "Batch",
    events: "Events",
    reload_device: "Reload device",
    reload_order: "Reload order",
    actions_selected: "Actions selected",
    stock: "Stock",
    reload: "Reload",
    selected_devices: "Selected devices",
    transfer_devices: "Transfer devices",
    current_devices_status: "Current devices status",
    lease_price_per_device_ex_vat: "Lease price per device ex. vat",
    lease: "Lease",
    number_of_devices_old: "No. Devices (old)",
    create_sold_event: "Create sold event",
    exact_code: "Exact code",
    kpi_type: "Kpi Type",
    from_id: "From id",
    export_customers: "Export customers",
    sold_devices: "Sold devices",
    past_range: "Past range",
    scheduled_range: "Scheduled range",
    needs_to_be_billed: "Needs to be billed",
    fieldtracker_task_name: "FT Task",
    service_call: "Service call",
    service_devices: "Service devices",
    service_device: "Service device",
    installation_form: "Installation form",
    request_service_call: "Request service call",
    request_install: "Request Install",
    all_devices_old: "All devices old",
    select_agent: "Select agent",
    customers_merge: "Customers merge",
    merge: "Merge",
    value: "Value",
    send_with_docusign: "Send with docusign",
    reload_customer: "Reload Customer",
    import: "Import",
    stats: "Stats",
    audits: "Audits",
    cancell_order: "Cancell Order",
    devices_action: "Devices Action",
    now: "Now",
    cancel_at: "Cancel At",
    cancel_cancellation: "Cancel Cancellation",
    export_devices: "Export Devices",
    completed: "Completed",
    number_of_devices: "Number of devices",
    set_as_paid: "Set as paid",
    create_credit: "Create credit",
    edit_internal_notes: "Edit internal notes",
    reset: "Reset",
    more: "More",
    refresh: "Refresh",
    first_page_preview: "First page preview",
    null: "",
    credit_this_invoice: "Credit this invoice",
    mark_as_paid: "Mark as paid",
    mollie_direct_debit: "Mollie",
    direct_debit: "Exact",
    charge_again: "Charge again",
    separate_install: "Separate install",
    request_separate_install: "Request separate install",
    request_separate_replace: "Request separate replace",
    separate_replace: "Separate replace",
    selected_device: "Selected device",
    separate_service_call: "Separate service call",
    request_separate_service_call: "Request separate service call",
    synatec_code: "Sinatec code",
    synatec_products: "Sinatec products",
    add_synatec_product: "Add Sinatec product",
    order_at_synatec: "Order @Sinatec",
    create_synatec_order: "Create sinatec order",
    send_to: "Send to",
    synatec_orders: "Sinatec orders",
    all_synatec_orders: "All Sinatec orders",
    requested: "Requested",
    fulfilled: "Fulfilled",
    accepted_at: "Accepted at",
    accepted_inquiries: "Accepted inquiries",
    terms_version: "Terms version",
    signed_by: "Signed by",
    has_signed_pdf: "Signed PDF",
    total_price_one_time: "Total one-time",
    total_price_per_month: "Total per month",
    webapp_registration: "Webapp registration",
    re_send_registration_email: "Resend registration email",
    new_ohra_order: "New ohra order",
    cable: "Cable",
    gps_only_cable: "Gps only cable",
    synatec_orders: "Synatec orders",
    ohra_create_order: "Ohra create order",
    disable_sending_invoices: "Disable sending invoices",
    enable_sending_invoices: "Enable sending invoices",
    price_list: "Price list",
    scheduled_termination_at: "Scheduled termination at",
    terminate_scheduled_by_customer: "Termination scheduled by customer",
    kill_list: "Kill list",
    reference: "Reference",
    process_type: "Process type",
    return_process: "Return process",
    terminate_at: "Terminate at",
    ft_status:"Fieldtracker status",
    terminations_by_myenv: "Terminations by MyEnv",

    add_photo: "Add photo",
    title: "Title",
    you_are_adding: "You are adding",
    you_are_removing: "You are removing",

    undo: "Undo",
    confirm_undo_termination: "Are you sure you want to undo the termination made by the customer?",
    this_week: "This week",
    discount_applied: "Discount applied",
    prefill_data: "Prefill data",
    select_device_type: "Select device type",
    select_task: "Select task",
    select_ft_task: "Select FT task",
    select_imei_identifier: "Select IMEI identifier",
    select_license_plate_identifier: "Select license plate identifier",

    product: "Product",
    requesters: "Requesters",
    pending: "Pending",
    pending_services: "Pending services",
    removed: "Removed",
    expired: "Expired",

    cannot_delete_order_with_requested_synatec_orders: "Cannot do hard delete of order with requested Sinatec orders",
    employed: "Employed",
    not_employed: "Not employed",
    displayed: "Displayed",
    not_displayed: "Not displayed",

    blocked_devices_for_pending_termination: "Blocked device(s) for pending termination",
    last_device: "Last device",
    has_not_paid_invoices: "Has not paid invoices",

    shipping_fee: "Shipping fee",
    set_shipping_fee: "Set as shipping fee",
    remove: "Remove",
    
    found: "Found",
    not_found: "Not found",
    match: "Match",
    no_match: "No match",

    awaiting_penalty_payment: "Awaiting penalty payment",
    payments_up_to_date: "Payments up to date",

    my_environment_exceptions: "MyEnvironment exceptions",
    payments_up_to_date: "Payments up to date",

    order_include_item: "Order include item",
    specific_item_included: "Specific item included in the order",
    optional: "Optional",
  },
  status: {
    devices_stock: "Devices Stock",
    devices_terminate: "Devices Terminate"
  },
  
  system_restriction: {
    title: "This record belongs to another system",
    description: "Switch to the record's system to view its information.",
    current_system: "Current system",
    record_system: "Record system",
    switch_to: "Switch to {system}",
    go_back: "Go back",
    no_access_title: "No access",
    no_access_description: "You don't have access to the {system} system.",
  },
  fleet: {
    owner: "Owner",
    paying_entity: "Paying entity",
    vehicle: "Vehicle",
    billing: "Billing",
    show_fleet_devices: "Show devices in Fleet",
    show_billing_devices: "Show devices in Billing",
    not_in_fleet: "Not in Fleet",
    not_in_billing: "Not in Billing",
    billing_lookup_failed: "Could not check Billing",
    fleet_lookup_failed: "Could not check Fleet",
    retry: "Retry",
    no_web_app_id: "Customer without web app ID",
    different_customer: "Different customer",
    unpaired: "Unpaired",
    different_owner_or_paying_entity: "Different owner or paying entity",
  },
  fieldtracker: {
    request_service: "Request Fieldtracker Service",
    task_type: "Task",
    save_and_notify: "Save and email customer",
    save_and_dont_notify: "Save and dont email customer",
    requester_name: "commissioned by",
    use_hq_as_default: "Use ULU HQ as default",
    send_sms: "Send SMS",
    device_type: "Device Type",
    task: "Task",
    api_identifier: "API Identifier",
    license_plate_identifier: "License plate identifier",
    imei_identifier: "IMEI identifier",
    
  },
  webshop:{
    position: "Position",
    move_up: "Move Up",
    move_down: "Move Down",
    set_position: "Set Position",
  }
};
// {{ $t("globals.CHANGE_ME") }}
// :text="$t('globals.CHANGE_ME')"
